// extracted by mini-css-extract-plugin
export var activeDot = "_9x-c";
export var buttonContainer = "_9x-9";
export var channelButton = "_9x-a";
export var clickable = "_9x-d";
export var content = "_9x-0";
export var contentFull = "_9x-2";
export var contentThird = "_9x-1";
export var contentWrapper = "_9x-7";
export var description = "_9x-5";
export var heightShort = "_9x-f";
export var image = "_9x-3";
export var imageContainer = "_9x-4";
export var selectButton = "_9x-e";
export var spinnerContainer = "_9x-b";
export var titleContent = "_9x-8";
export var titleWrapper = "_9x-6";